/* eslint-disable complexity */
function removeUniId(link) {
    if (!link || !link.includes('uni_id')) {
        return link;
    }

    const regExp = new RegExp(/uni_id=?(\d+)/);
    const localLink = link.replace(regExp, '');

    // remove delimiter of removed parameter
    if (localLink.endsWith('?') || localLink.endsWith('&')) {
        return localLink.slice(0, -1);
    } else if (localLink.includes('&&')) {
        return localLink.replace('&&', '&');
    } else if (localLink.includes('?&')) {
        return localLink.replace('?&', '?');
    }

    return localLink;
}
/* eslint-enable complexity */

module.exports = removeUniId;
